import React from 'react'
import styled from 'styled-components'
import ContentArea from '../components/ContentArea'
import SelectButton from '../components/SelectButton'

const ImageryPage = () => {
    const HomeHeader = styled.h1`
    font-weight: 500;
    width: 70%;
    margin: 0 auto 53pt !important;
    text-align: center;
    font-size: 20pt;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `
    return (
        <ContentArea transparent shadowless fullsize>
            <div>
                <div>
                    <HomeHeader>Guided Imagery </HomeHeader>
                    <SelectButton
                        value="Ego Strengthening"
                        link
                        linkto={`/imagery/video/egostrengthening`}
                    />
                    <SelectButton
                        value="Self Hypnosis"
                        link
                        linkto={`/imagery/video/selfhypnosis`}
                    />
                </div>
            </div>

        </ContentArea>
    )
}

export default ImageryPage